import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import uuid from 'uuid-random';
import { sendTrackingInfo, ModalBase } from '@panel/commons';
import SectionLayout from '../SectionLayout';
import { formatValue } from '../../helpers/utils';
import StarIcon from '../../assets/icons/star.svg';
import ChevronDownIcon from '../../assets/icons/chevron_right.svg';
import StarsRating from '../StarsRating';
import { ReputationSelectors } from '../../ducks/reputation';
import { dataRatingsAdapter } from '../dataRatingsAdapter';
import EmptyStateScore from '../EmptyStateScore';
import { Modal } from '../Modals/ModalWrapper';
import Comment from '../Comment';
import {
  Container,
  TitleText,
  MainArea,
  LeftSide,
  ContainerRaitings,
  Rating,
  RightSide,
  ProgressBarContainer,
  TotalvalueContainer,
  TotalValueSpan,
  LinkToHelp,
  ContainerValue,
  BottomSheetContainer,
  BottomSheetTitle,
  MoreComments,
  ChevronDown,
  ModalContainer,
  CommentsContainer,
  TitleContainer,
  BajadaContainer,
  ContainerModalBody,
  RightModal,
  LeftModal,
  ContainerValueModal,
  RatingModal,
  ProgressBarFill,
  RatingTextModal,
  HeaderSectionContainer,
  MobileBajadaContainer,
  MobileBajadaContainerModal,
  Parrafo,
  LineDiv,
  TotalvalueContainerMobile
} from './styles';
import './buttonSheetStyles.css';

const PublisherLevelSection = ({ device, reloadDispatch, sendCustomTrackingInfo }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const isTablet = device === 'tablet';
  const [ratingsData, setRatingsData] = useState({});
  const [progressBarData, setProgressBarData] = useState([]);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [scrollDLSend, setScrollDLSend] = useState(false);
  const { ratings, ratingsError, customersComments } = useSelector(ReputationSelectors.getReputationState);

  const {
    generalScore,
    totalRatings,
    responseTime,
    postingContent,
    attention,
    recommendYou,
    notRespondedCount
  } = ratingsData;

  useEffect(() => {
    if (ratings) setRatingsData(dataRatingsAdapter(ratings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratings]);

  const handleScroll = event => {
    if (event.currentTarget.scrollTop && !scrollDLSend) {
      sendCustomTrackingInfo({
        event: 'scroll_comments',
        content_type: 'Estadisticas - Reputación'
      });
      setScrollDLSend(true);
    }
  };

  useEffect(() => {
    setProgressBarData([
      { value: postingContent },
      { value: responseTime },
      { value: attention },
      { value: recommendYou }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingsData]);

  const getInfoTotalValues = () => {
    if (totalRatings > 0) {
      return (
        <TotalValueSpan device={device} data-panel='ratings-Totalvalue'>
          {t(`panel.reputacion.attention.modal.bajada`, {
            value: totalRatings || '0'
          })}
        </TotalValueSpan>
      );
    }
    return <div className='emptyState'>{t('panel.estadisticas.ratings.emptyStateText')}</div>;
  };

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  return (
    <SectionLayout
      data-panel='panel-estadisticas-rating-leads'
      marginTop='0px'
      paddingBottom={notRespondedCount ? '0' : null}
    >
      {device === 'desktop' && (
        <Container>
          {!ratingsError ? (
            <MainArea device={device} notRespondedCount={notRespondedCount}>
              <LeftSide device={device} data-panel='ratings-container-leftSide'>
                <TitleContainer> {t('panel.reputacion.attention.title')}</TitleContainer>
                <BajadaContainer>
                  {generalScore != null
                    ? t('panel.reputacion.attention.bajada')
                    : t('panel.reputacion.attention.bajada.nodata')}
                </BajadaContainer>
                {generalScore && ((isMobile && generalScore != null) || generalScore != null) && (
                  <MoreComments
                    device={device}
                    onClick={() => {
                      if (isMobile || isTablet) setOpenBottomSheet(true);
                      if (!isMobile && !isTablet) setShowModal(true);
                      sendCustomTrackingInfo({
                        event: 'select_content',
                        content_type: 'Estadisticas - Reputación',
                        item_id: 'Ver opiniones'
                      });
                    }}
                  >
                    {t('panel.reputacion.attention.cta')}
                    <ChevronDown
                      data-panel='ratings-moreComments-chevron'
                      src={showModal || openBottomSheet ? ChevronDownIcon : ChevronDownIcon}
                      alt='chevron-down'
                    />
                  </MoreComments>
                )}
              </LeftSide>
              <RightSide device={device} data-panel='ratings-container-rightSide'>
                <ContainerRaitings device={device} generalScore={generalScore}>
                  <Rating>
                    <StarsRating
                      width='16px'
                      height='16px'
                      icon={StarIcon}
                      value={generalScore}
                      numOfStars='5'
                      dataPanel='container-ratings-stars'
                    />
                  </Rating>

                  <ContainerValue data-panel='ratings-value'>{formatValue(generalScore)}</ContainerValue>
                </ContainerRaitings>
              </RightSide>
              {showModal && !isMobile && (
                <Modal>
                  <ModalBase
                    openModal={showModal}
                    onClose={() => {
                      setScrollDLSend(false);
                      setShowModal(false);
                    }}
                    width='696px'
                    height='508px'
                    rightPosition='25px'
                    topPosition='25px'
                  >
                    <ModalContainer>
                      <TitleText data-panel='ratings-moreComments-modal-title' mBottom='32px' fontSize='20px'>
                        {t('panel.reputacion.attention.modal.title')}
                      </TitleText>
                      <ContainerModalBody>
                        <RightModal>
                          <ContainerRaitings device={device} generalScore={generalScore}>
                            <ContainerValueModal key={uuid()} data-panel='ratings-value'>
                              {formatValue(generalScore)}
                            </ContainerValueModal>
                            <RatingModal>
                              <StarsRating
                                width='40px'
                                height='38px'
                                icon={StarIcon}
                                value={generalScore}
                                numOfStars='5'
                                dataPanel='container-ratings-stars'
                              />
                              <TotalvalueContainer data-panel='ratings-container-Totalvalue'>
                                {getInfoTotalValues()}
                              </TotalvalueContainer>

                              {progressBarData &&
                                progressBarData.map((element, i) => {
                                  return (
                                    <React.Fragment key={uuid()}>
                                      <RatingTextModal
                                        device={device}
                                        data-panel={`progressBar-text-${i}`}
                                        style={{
                                          width: '95%'
                                        }}
                                      >
                                        {t(`panel.estadisticas.ratings.question.${i + 1}`)}
                                        <span>{`${element.value}/5`}</span> {/* Número a la derecha */}
                                      </RatingTextModal>
                                      <ProgressBarContainer>
                                        <ProgressBarFill percentage={(element.value / 5) * 100} />
                                      </ProgressBarContainer>
                                    </React.Fragment>
                                  );
                                })}

                              <LinkToHelp
                                device={device}
                                href={t('panel.reputacion.attention.modal.link')}
                                target='_blank'
                                rel='noopener noreferrer'
                                data-panel='ratings-info-linkToHelp'
                                onClick={() => sendTrackingInfo('Panel', 'Estadisticas', 'Reputación-Ayuda')}
                              >
                                {t('panel.reputation.attention.link.title')}
                              </LinkToHelp>
                            </RatingModal>
                          </ContainerRaitings>
                        </RightModal>
                        {customersComments.length > 0 && (
                          <LeftModal>
                            <CommentsContainer
                              onScroll={handleScroll}
                              data-panel='ratings-moreComments-modal-container'
                            >
                              {customersComments.map(customerComment => (
                                <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                              ))}
                            </CommentsContainer>
                          </LeftModal>
                        )}
                      </ContainerModalBody>
                    </ModalContainer>
                  </ModalBase>
                </Modal>
              )}
            </MainArea>
          ) : (
            <EmptyStateScore
              withSpacing={device === 'desktop'}
              height={isMobile ? '160px' : '115px'}
              top={getTopEmptyState()}
              callback={reloadDispatch}
              text={t('panel.reputacion.attention.title')}
            />
          )}
        </Container>
      )}

      {!ratingsError && device !== 'desktop' && (
        <Container>
          <HeaderSectionContainer>
            <TitleContainer> {t('panel.reputacion.attention.title')}</TitleContainer>
          </HeaderSectionContainer>
          <MobileBajadaContainer>
            <Parrafo>{t('panel.reputacion.attention.bajada')}</Parrafo>
          </MobileBajadaContainer>
          <HeaderSectionContainer>
            <ContainerRaitings device={device} generalScore={generalScore}>
              <Rating>
                <StarsRating
                  width='16px'
                  height='16px'
                  icon={StarIcon}
                  value={generalScore}
                  numOfStars='5'
                  dataPanel='container-ratings-stars'
                />
              </Rating>

              <ContainerValue data-panel='ratings-value'>{formatValue(generalScore)}</ContainerValue>
            </ContainerRaitings>
            {generalScore && ((isMobile && generalScore != null) || generalScore != null) && (
              <MoreComments
                onClick={() => {
                  setOpenBottomSheet(true);
                  setShowModal(true);
                  sendCustomTrackingInfo({
                    event: 'select_content',
                    content_group: 'Estadisticas - Reputación',
                    item_id: 'Ver comentarios'
                  });
                }}
              >
                {t('panel.reputacion.attention.cta')}
                <ChevronDown
                  data-panel='ratings-moreComments-chevron'
                  src={showModal || openBottomSheet ? ChevronDownIcon : ChevronDownIcon}
                  alt='chevron-down'
                />
              </MoreComments>
            )}
          </HeaderSectionContainer>
          {(isMobile || isTablet) && (
            <BottomSheet
              open={openBottomSheet}
              onDismiss={() => setOpenBottomSheet(false)}
              snapPoints={({ maxHeight }) => [maxHeight / 1.12]}
              header={React.createElement(
                'div',
                {},
                <BottomSheetTitle data-panel='ratings-bottomSheet-title'>
                  {t('panel.reputacion.attention.modal.title')}
                </BottomSheetTitle>
              )}
            >
              <BottomSheetContainer>
                <MobileBajadaContainerModal>
                  <ContainerValue data-panel='ratings-value'>{formatValue(generalScore)}</ContainerValue>
                  <Rating
                    style={{
                      width: 'auto'
                    }}
                  >
                    <StarsRating
                      width='38px'
                      height='38px'
                      icon={StarIcon}
                      value={generalScore}
                      numOfStars='5'
                      dataPanel='container-ratings-stars'
                    />
                  </Rating>

                  <TotalvalueContainerMobile data-panel='ratings-container-Totalvalue'>
                    {getInfoTotalValues()}
                  </TotalvalueContainerMobile>
                  {progressBarData &&
                    progressBarData.map((element, i) => {
                      return (
                        <React.Fragment key={uuid()}>
                          <RatingTextModal device={device} data-panel={`progressBar-text-${i}`}>
                            {t(`panel.estadisticas.ratings.question.${i + 1}`)}
                            <span>{`${element.value}/5`}</span> {/* Número a la derecha */}
                          </RatingTextModal>
                          <ProgressBarContainer>
                            <ProgressBarFill percentage={(element.value / 5) * 100} />
                          </ProgressBarContainer>
                        </React.Fragment>
                      );
                    })}

                  <LinkToHelp
                    device={device}
                    href={t('panel.reputacion.attention.modal.link')}
                    target='_blank'
                    rel='noopener noreferrer'
                    data-panel='ratings-info-linkToHelp'
                    onClick={() => sendTrackingInfo('Panel', 'Estadisticas', 'Reputación-Ayuda')}
                  >
                    {t('panel.reputation.attention.link.title')}
                  </LinkToHelp>

                  <LineDiv />
                </MobileBajadaContainerModal>

                <CommentsContainer device={device} height='429px' data-panel='ratings-bottomSheet-container'>
                  {customersComments &&
                    customersComments.map(customerComment => (
                      <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                    ))}
                </CommentsContainer>
              </BottomSheetContainer>
            </BottomSheet>
          )}
        </Container>
      )}

      {ratingsError && device !== 'desktop' && (
        <EmptyStateScore
          withSpacing={device === 'desktop'}
          height={isMobile ? '160px' : '115px'}
          callback={reloadDispatch}
          text={t('panel.reputacion.attention.title')}
        />
      )}
    </SectionLayout>
  );
};

export default PublisherLevelSection;
